import { createSlice } from "@reduxjs/toolkit";

import {
  buildInitialGroups,
  collapsibleSizesFor,
  expandedSizesFor,
  setSizes,
} from "./helpers";

export const initialState = { groups: buildInitialGroups() };

export const panelsSlice = createSlice({
  name: "panels",
  initialState,
  reducers: {
    setPanelSize: (state, { payload: { groupId, panelId, size } }) => {
      setSizes(state, groupId, { [panelId]: size });
    },
    collapsePanel: (state, { payload: { groupId, panelId } }) => {
      const panel = state.groups[groupId]?.panels[panelId];
      if (!panel) {
        return;
      }
      setSizes(state, groupId, { [panelId]: panel.collapsedSize ?? 0 });
    },
    expandPanel: (state, { payload: { groupId, panelId } }) => {
      const panel = state.groups[groupId]?.panels[panelId];
      if (!panel) {
        return;
      }
      setSizes(state, groupId, { [panelId]: panel.defaultSize });
    },
    collapsePanelGroup: (state, { payload: { groupId } }) => {
      const group = state.groups[groupId];
      if (!group) {
        return;
      }
      setSizes(state, groupId, collapsibleSizesFor(group));
    },
    expandPanelGroup: (state, { payload: { groupId } }) => {
      const group = state.groups[groupId];
      if (!group) {
        return;
      }
      setSizes(state, groupId, expandedSizesFor(group));
    },
  },
});

export const {
  setPanelSize,
  collapsePanel,
  expandPanel,
  collapsePanelGroup,
  expandPanelGroup,
} = panelsSlice.actions;

export default panelsSlice.reducer;
